import { render, staticRenderFns } from "./PhysicianSurgeonSpecialistOrDoctor.vue?vue&type=template&id=041c203a&scoped=true"
import script from "./PhysicianSurgeonSpecialistOrDoctor.vue?vue&type=script&lang=js"
export * from "./PhysicianSurgeonSpecialistOrDoctor.vue?vue&type=script&lang=js"
import style0 from "./PhysicianSurgeonSpecialistOrDoctor.vue?vue&type=style&index=0&id=041c203a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041c203a",
  null
  
)

export default component.exports